import { createFileRoute } from '@tanstack/react-router';
import { EcranConnexion } from '../connexion/EcranConnexion';

export const Route = createFileRoute('/connexion')({
  component: EcranConnexion,
});
